export enum TransactionFilterField {
  TRANSACTION_TYPE = 'type',
  STATUS = 'status',
  FROM_DATE = 'fromDate',
  TO_DATE = 'toDate',
  AMOUNT = 'amount',
  CURRENCY = 'currency',
  SENDER = 'beneficiaryId',
  RECIPIENT = 'recipientId',
  TRANSACTION_ID = 'id',
  AWAITING_FUNDING = 'awaitingFunding',
}

export const ALL_ACTIVITY_FILTERS: readonly TransactionFilterField[] = [
  TransactionFilterField.TRANSACTION_TYPE,
  TransactionFilterField.STATUS,
  TransactionFilterField.FROM_DATE,
  TransactionFilterField.TO_DATE,
  TransactionFilterField.AMOUNT,
  TransactionFilterField.CURRENCY,
  TransactionFilterField.SENDER,
  TransactionFilterField.RECIPIENT,
  TransactionFilterField.TRANSACTION_ID,
  TransactionFilterField.AWAITING_FUNDING,
];

export const CUSTOMER_ACTIVITY_FILTERS: readonly TransactionFilterField[] = [
  TransactionFilterField.TRANSACTION_TYPE,
  TransactionFilterField.STATUS,
  TransactionFilterField.FROM_DATE,
  TransactionFilterField.TO_DATE,
  TransactionFilterField.AMOUNT,
  TransactionFilterField.CURRENCY,
  TransactionFilterField.RECIPIENT,
  TransactionFilterField.TRANSACTION_ID,
];
